var map = {
	"./cat.jpg": 9972,
	"./catch.jpg": 8428,
	"./eCard.jpg": 5616,
	"./hand.jpg": 2840,
	"./hat.jpg": 3732,
	"./jCard.jpg": 4972,
	"./land.jpg": 3300,
	"./man.jpg": 2539,
	"./plan.jpg": 1764,
	"./plastic.jpg": 7100,
	"./salad.jpg": 3116,
	"./stand.jpg": 5032,
	"./wordCard.jpg": 3668
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1440;